<template>
        <div class="Kyuyo_MainArea">
          <b-container fluid>
            <!-- メニュー -->
            <b-row>
              <!-- <b-col cols="8"> -->
              <b-col cols="12">
                <b-card>
              <b-row>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/WorkRegist">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_Work_Regist">
                      <b-icon icon="file-earmark-spreadsheet"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">勤怠報告</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/WorkCalendar">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_Work_Calendar">
                      <b-icon icon="calendar3"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">カレンダー</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/ApplicationRegist">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_Application_Regist">
                      <b-icon icon="file-earmark-arrow-up"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">事前申請</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/Approval" :disabled="(systemAuthorityType == null || systemAuthorityType == 0)">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_Approval">
                      <b-icon icon="person-check-fill"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">承認</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/ApplicationHistory">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_Approval">
                      <b-icon icon="person-check"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">承認状況</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/ApprovalHistory" :disabled="(systemAuthorityType == null || systemAuthorityType == 0)">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_Approval">
                      <b-icon icon="person-check-fill"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">承認履歴</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/SubstituteHolidayManage">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_SubstituteHolidayManage">
                      <b-icon icon="calendar-check"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">振替残管理</div>
                  </b-button>
                </b-col>
                <!-- <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/MailResend" disabled>
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_MailResend">
                      <b-icon icon="envelope"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">メール再通知</div>
                  </b-button>
                </b-col> -->
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/WorkSummary" :disabled="(systemAuthorityType == null || systemAuthorityType == 0)">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_WorkSummary">
                      <b-icon icon="table"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">集計表</div>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/AttendanceCheck">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_AttendanceCheck">
                      <b-icon icon="person-lines-fill"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">在席確認</div>
                  </b-button>
                </b-col>
                <!-- <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/ProxyApplication" disabled>
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_ProxyApplication">
                      <b-icon icon="people"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">代理申請設定/解除</div>
                  </b-button>
                </b-col> -->
                <b-col cols="4">
                  <b-button class="Kyuyo_HomeMenu__Button_Type1" variant="light" to="/manager/WorkState">
                    <div class="d-flex justify-content-center h1 Kyuyo_HomeMenu__Button_Icon_WorkState">
                      <b-icon icon="table"></b-icon>
                    </div>
                    <div class="d-flex justify-content-center">勤務状況</div>
                  </b-button>
                </b-col>
              </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </div>
  </template>

  <script>
  export default {
    name: "Home",
    components: {},
    data() {
      return {
        contractCount: "30",
        ValidLicenseCount: "200",
        loginUserId: null,
        systemAuthorityType: 0,
      };
    },
    mounted: function () {
      // this.getWareki();
      this.loginUserId = this.$store.state.user_id;
      this.systemAuthorityType = this.$store.state.system_authority_type;
      console.debug("systemAuthorityType：" + this.systemAuthorityType);
    },
    methods: {
    },
  };
</script>
<style>
.Kyuyo_HomeInfoCard {
  background: linear-gradient(25deg, rgb(125, 125, 255), rgb(44, 76, 255));
  color: white;
}

.Kyuyo_HomeMenu__Button {
  border-radius: 5px !important;
  width: 100%;
  padding: 2rem !important;
  text-align: left !important;
  margin: 5px;
  font-size: 1.4rem !important;
}

.Kyuyo_HomeMenu__Button_Type1 {
  border-radius: 5px !important;
  width: 100%;
  padding: 2rem !important;
  text-align: center !important;
  margin: 5px;
  font-size: 1rem !important;
  /* color:rgb(44, 76, 255) !important; */
}

.Kyuyo_HomeMenu__Button_Icon {
  color:rgb(44, 76, 255) !important;
}

.Kyuyo_HomeMenu__Button_Icon_Work_Regist {
  color:rgb(33, 37, 41) !important;
}

.Kyuyo_HomeMenu__Button_Icon_Work_Calendar {
  color:rgb(33, 37, 41) !important;
}

.Kyuyo_HomeMenu__Button_Icon_Application_Regist {
  color:rgb(255, 44, 44) !important;
}

.Kyuyo_HomeMenu__Button_Icon_Approval {
  color:rgb(255, 44, 44) !important;
}

.Kyuyo_HomeMenu__Button_Icon_SubstituteHolidayManage {
  color:rgb(13, 91, 128) !important;
}

.Kyuyo_HomeMenu__Button_Icon_MailResend {
  color:rgb(44, 76, 255) !important;
}

.Kyuyo_HomeMenu__Button_Icon_WorkSummary {
  color:rgb(44, 150, 91) !important;
}

.Kyuyo_HomeMenu__Button_Icon_AttendanceCheck {
  color:rgb(255, 160, 44) !important;
}

.Kyuyo_HomeMenu__Button_Icon_ProxyApplication {
  color:rgb(255, 44, 44) !important;
}

.Kyuyo_HomeMenu__Button_Icon_WorkState {
  color:rgb(44, 150, 91) !important;
}

.Kyuyo_MainArea {
  margin-left: 10px;
  margin-right: 10px;
}

</style>

